import React from "react";
import Testimonials from "../home/Testimonials";

const HiringTestimonials = () => {
  return <Testimonials />;
};

export default HiringTestimonials;
